module.exports = __webpack_public_path__ + "static/media/nathan-kistenmacker.d9bf98dd.png";